// // import React, { createContext, useContext, useMemo, useState, useCallback } from "react";

// // const MessagesContext = createContext(null);

// // export const MessagesProvider = ({ children }) => {
// //   const [isOpen, setIsOpen] = useState(false);
// //   const [initialThreadId, setInitialThreadId] = useState(null);
// //   const [refreshToken, setRefreshToken] = useState(0);

// //   const triggerRefresh = () => setRefreshToken(t => t + 1);

// //   const openMessages = useCallback((opts = {}) => {
// //     setInitialThreadId(opts.threadId ?? null);
// //     setIsOpen(true);
// //   }, []);

// //   const closeMessages = useCallback(() => {
// //     setIsOpen(false);
// //     setInitialThreadId(null);
// //   }, []);

// //   const value = useMemo(() => ({ isOpen, initialThreadId, openMessages, closeMessages }), [
// //     isOpen,
// //     initialThreadId,
// //     openMessages,
// //     closeMessages,
// //   ]);

// //   // return <MessagesContext.Provider value={value}>{children}</MessagesContext.Provider>;
// //   return (
// //     <MessagesContext.Provider value={{
// //       isOpen,
// //       openMessages: () => setIsOpen(true),
// //       closeMessages: () => setIsOpen(false),
// //       refreshToken,
// //       triggerRefresh
// //     }}>
// //       {children}
// //     </MessagesContext.Provider>
// //   );
// // };

// // export const useMessagesUI = () => {
// //   const ctx = useContext(MessagesContext);
// //   if (!ctx) throw new Error("useMessagesUI must be used within <MessagesProvider>");
// //   return ctx;
// // };

// // client/src/context/MessagesContext.jsx
// import React, { createContext, useContext, useState, useCallback } from 'react';

// const MessagesContext = createContext(undefined);

// export function MessagesProvider({ children }) {
//   const [isOpen, setIsOpen] = useState(false);
//   const [activeThreadId, setActiveThreadId] = useState(null);

//   const openMessages = useCallback((threadId = null) => {
//     setActiveThreadId(threadId);
//     setIsOpen(true);
//   }, []);

//   const closeMessages = useCallback(() => {
//     setIsOpen(false);
//     setActiveThreadId(null);
//   }, []);

//   const value = {
//     isOpen,
//     activeThreadId,
//     openMessages,
//     closeMessages
//   };

//   return (
//     <MessagesContext.Provider value={value}>
//       {children}
//     </MessagesContext.Provider>
//   );
// }

// export function useMessagesUI() {
//   const context = useContext(MessagesContext);
//   if (context === undefined) {
//     throw new Error('useMessagesUI must be used within <MessagesProvider>');
//   }
//   return context;
// }

// export { MessagesContext };
// export default MessagesContext;

// client/src/context/MessagesContext.jsx
import React, { createContext, useContext, useState, useCallback } from 'react';

const MessagesContext = createContext(undefined);

export function MessagesProvider({ children }) {
  const [isOpen, setIsOpen] = useState(false);
  const [activeThreadId, setActiveThreadId] = useState(null);

  const openMessages = useCallback((threadId = null) => {
    setActiveThreadId(threadId);
    setIsOpen(true);
  }, []);

  const closeMessages = useCallback(() => {
    setIsOpen(false);
    setActiveThreadId(null);
  }, []);

  const value = {
    isOpen,
    activeThreadId,
    openMessages,
    closeMessages
  };

  return (
    <MessagesContext.Provider value={value}>
      {children}
    </MessagesContext.Provider>
  );
}

export function useMessagesUI() {
  const context = useContext(MessagesContext);
  if (context === undefined) {
    throw new Error('useMessagesUI must be used within <MessagesProvider>');
  }
  return context;
}

export { MessagesContext };
export default MessagesContext;